import { JetpacB2BApi } from 'api'

class B2bTDPAPI {
  static getTDPDetails(faberToken: string, params?: Record<string, string>) {
    const queryString = params
      ? Object.entries(params)
          .filter(([, value]) => value && value.trim() !== '')
          .map(
            ([key, value]) =>
              `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
          )
          .join('&')
      : ''

    return JetpacB2BApi.httpGet(
      `/tenant-detail${queryString ? `?${queryString}` : ''}`,
      {
        Authorization: `Bearer ${faberToken}`
      }
    ).then((res) => res.data)
  }
  static getTDPDetailsById(faberToken: string, id: string) {
    return JetpacB2BApi.httpGet(`/tenant-detail/${id}`, {
      Authorization: `Bearer ${faberToken}`
    }).then((res) => res.data)
  }

  static async saveTDPDetails(
    body: ITDPBackendData,
    faberToken: string
    // id?: string
  ) {
    return JetpacB2BApi.httpPost(
      `tenant-detail`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      body
    )
  }
  static async updateTDPStatus(
    body: ITDPStausUpdateBackendData,
    faberToken: string
    // id?: string
  ) {
    return JetpacB2BApi.httpPatch(
      `tenant-detail/status`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      body
    )
  }
  static async updateTDPDetails(
    body: ITDPBackendData,
    faberToken: string
    // id?: string
  ) {
    return JetpacB2BApi.httpPut(
      `tenant-detail`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      body
    )
  }
}

export default B2bTDPAPI

// ----- TenantDetails payload (matches Go struct json tags) -----
export interface ITenantDetailsPayload {
  contact_person_first_name: string
  contact_person_last_name: string
  contact_person_email: string
  contact_person_phone_code: string
  contract_person_phone_number: string
  promoting_esim: boolean
  sold_esim_count: number
  projected_esim_sales_count: number
  approximate_project_monthly_volume: string
  approximate_monthly_volume: string
  expected_book_ratio: number
  prefered_currency_transactions: string
  company_logo: string
  referral_source: string
  technology_company: string
  business_registration_certificate: string
  tax_identification_certificate: string
  authorized_signatory: string
  rebate_period: string
  assign_product: string
  account_manager: string
  internal_remarks: string
  approver: string
  approval_on?: string | null // ISO string or null
  approver_remarks: string
}

// ----- Tenant (top level) payload (matches Go struct json tags) -----
export interface ITDPBackendData {
  tenant_code?: string
  company_name: string
  tenant_type?: string
  legal_business_name: string
  business_registration_number: string
  business_type: string
  country: string
  city: string
  registered_business_address: string
  website_url: string
  tenant_currency: string
  status: string
  is_active: boolean
  communication_lang
  created_by?: string
  updated_by?: string
  TenantDetails: ITenantDetailsPayload
  // This is optional field will only be present if user edits the TDP
  id?: string
}

export interface ITDPStausUpdateBackendData {
  id: string
  updated_by: string
  status: boolean
}
